const specialChars = [' ', '-', '\'', '.'];

function IsLetter(letter: string): boolean {
    return letter.toUpperCase() != letter.toLowerCase();
}

export function BeautifyString(input: string | null | undefined): string {
    if (input == undefined || input === null) {
        return "";
    }

    input = input.trim();

    let flag: boolean = true;
    let text: string = "";

    input = input.toLowerCase();
    for (let i = 0; i < input.length; i++) {
        let char: string = input.charAt(i);

        if (specialChars.includes(char)) {
            flag = true;
        }
        else if (IsLetter(char) && flag) {
            char = char.toUpperCase();
            flag = false;
        }

        text += char;
    }

    return text;
}

export function BeautifyUppercase(input: string | null | undefined): string {
    if (input == undefined || input === null) {
        return "";
    }

    input = input.trim();

    return input.toUpperCase();
}